import React from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ButtonGroup,
  Button,
  useDisclosure,
  Box,
} from "@chakra-ui/react";

export function ModalButton({
  label, colorScheme, title, children, callback, actionLabel, handleReset, isVisible = true
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  if (!isVisible) return null;
  const _onOpen = () => { handleReset(); onOpen(); }
  
  const modalBg = 'white';
  const headerBg = 'gray.50';
  const borderColor = 'gray.200';
  const overlayBg = 'blackAlpha.300';
  const boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
  
  return (
    <>
    <Button 
      colorScheme={colorScheme} 
      variant='outline' 
      size='sm' 
      onClick={onOpen}
      borderWidth={2}
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: 'lg',
      }}
      transition="all 0.3s ease"
    >
      { label }
    </Button>
    <Modal 
      isCentered 
      returnFocusOnClose={false} 
      isOpen={isOpen} 
      onClose={onClose} 
      onOpen={_onOpen} 
      placement="center" 
      closeOnBlur={false}
      size="lg"
    >
      <ModalOverlay 
        bg={overlayBg} 
        backdropFilter='blur(10px)' 
      />
      <ModalContent 
        bg={modalBg}
        borderRadius="2xl"
        boxShadow={boxShadow}
        border="1px solid"
        borderColor={borderColor}
      >
        <Box
          bg={headerBg}
          borderTopRadius="2xl"
          borderBottom="1px solid"
          borderColor={borderColor}
        >
          <ModalHeader 
            fontWeight="bold" 
            fontSize="lg"
            py={4}
          >
            { title || label }
          </ModalHeader>
          <ModalCloseButton 
            top={4}
            right={4}
            _hover={{
              bg: 'red.100',
              color: 'red.600'
            }}
            borderRadius="full"
          />
        </Box>
        <ModalBody py={6}>{ children }</ModalBody>
        <ModalFooter 
          display="flex" 
          justifyContent="flex-end"
          borderTop="1px solid"
          borderColor={borderColor}
          bg={headerBg}
          borderBottomRadius="2xl"
          py={4}
        >
          <ButtonGroup size="sm" spacing={3}>
            <Button 
              onClick={onClose} 
              colorScheme="gray" 
              variant="outline"
              _hover={{
                transform: 'translateY(-1px)',
                boxShadow: 'md'
              }}
              transition="all 0.2s ease"
            >
              İptal
            </Button>
            <Button 
              colorScheme='teal' 
              onClick={() => { callback(); }}
              _hover={{
                transform: 'translateY(-1px)',
                boxShadow: 'md'
              }}
              transition="all 0.2s ease"
            >
              { actionLabel || 'Evet' }
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
    </>
  )
}

